import React from 'react';

import { Tag } from '+/components/Tag';

interface MarkdownTagProps {
  children: string;
}

export const MarkdownTag = ({ children }: MarkdownTagProps) => <Tag text={children} />;
